import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckboxOutlineBlank = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M120-120v-720h720v720H120Zm60-60h600v-600H180v600Z" })
});
export default SvgCheckboxOutlineBlank;
